// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__P5ocn","logo":"styles_logo__6Ujw0","tab":"styles_tab__hRZF5","signInWithGoogleButton":"styles_signInWithGoogleButton__F0vmq"};